export { SredProjectsLayout } from './SredProjectsLayout';
